export default __webpack_public_path__ + "static/media/new.7fdcdb86.svg";